export default function (nga, admin, menu) {
    var _ename = 'purchases';
    var _epretty = 'Purchases';
    var _entity = nga.entity(_ename);
    
    _entity.listView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('purchase_method_id', 'reference')
                .targetEntity(nga.entity('purchasemethods'))
                .targetField(nga.field('name'))
                .label('Purchase Method'),
            nga.field('amount').label('Amount'),
            nga.field('vat_amount').label('Vat Amount'),
            nga.field('status').label('Status'),
            nga.field('created_at').label('Data da Criação'),
            nga.field('user_id', 'reference')
                .targetEntity(nga.entity('users'))
                .targetField(nga.field('email'))
                .label('User'),
            nga.field('').label('').template('<kts-authorize-purchase purchase="entry.values"></kts-authorize-purchase><kts-cancel-purchase purchase="entry.values"></kts-cancel-purchase>')
        ])
        .sortField('created_at')
        .sortDir('desc')
        .listActions(['show']);

    _entity.showView()
        .title(_epretty)
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('purchase_method_id', 'reference')
                .targetEntity(nga.entity('purchasemethods'))
                .targetField(nga.field('name'))
                .label('Purchase Method'),
            nga.field('amount').label('Amount'),
            nga.field('vat_amount').label('Vat Amount'),
            nga.field('status').label('Status'),
            nga.field('created_at').label('Data da Criação'),
            nga.field('user_id', 'reference')
                .targetEntity(nga.entity('users'))
                .targetField(nga.field('email'))
                .label('User'),
            nga.field('').label('').template('<kts-authorize-purchase purchase="entry.values"></kts-authorize-purchase><kts-cancel-purchase purchase="entry.values"></kts-cancel-purchase>')
        ]);
        

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/purchase.js